import { Modal, ModalBody } from "reactstrap"
import styles from './LiveSupport.module.scss'
import MeritoButton from "../../../../components/common/MeritoButtons/MeritoButtons"
import { RiCloseFill } from "react-icons/ri"
import { useState } from "react"
import { HiCheckCircle } from "react-icons/hi"
import { RestS } from "../../../../rest/rest-service"

type Props = {
  isOpen: boolean,
  setIsOpen: Function
}

export const LiveSupport = ({ isOpen, setIsOpen }: Props) => {
  const [message, setMessage] = useState('')
  const [step, setStep] = useState(1)

  const close = () => {
    setIsOpen(false)
    setStep(1)
    setMessage('')
  }

  return (
    <Modal isOpen={isOpen} size='md' centered={true} contentClassName={styles.contentBox} >
      {
        step == 1 ?
          // Live Support Input
          <div className={styles.container}>
            <div className={styles.header}>
              <p>Chat with Support</p>
              <MeritoButton type='secondary-1' size='md' onlyIcon={true} icon={<RiCloseFill />} onClick={() => close()} />
            </div>
            <div className={styles.body}>
              <p>What can we help you with?</p>
              <textarea rows={6} onChange={(e) => setMessage(e.target.value)} />
              <p className={styles.info}>Alternatively, reach out to us at <span>+91 9867054499</span></p>
            </div>
            <div className={styles.footer}>
              <MeritoButton type='secondary-2' size='lg' btnText='Close' isRounded={true} onClick={() => close()} />
              <MeritoButton disabled={message == ''} type='primary-1' size='lg' btnText='Send Message' isRounded={true} onClick={() => {
                console.log(`Sending Message... ${message}`);
                RestS.sendSupportMessage(message)
                setStep(2)
              }} />
            </div>
          </div>
          :
          // Success Screen
          <div className={styles.successContainer}>
            <div></div>
            <div className={styles.successBody}>
              <HiCheckCircle />
              <h2>Thanks, we got your message!</h2>
              <p>We're on it and will get back to you shortly</p>
            </div>
            <div className={styles.successFooter}>
              <MeritoButton type='secondary-2' size='lg' btnText='Close' isRounded={true} onClick={() => close()} />
            </div>
          </div>
      }
    </Modal>
  )
}